import { useState } from "react";
import "./VSwitchButton.css";
import { COLORS } from "../../../utils/Colors";

interface VSwitchButtonProps {
  labelFirst: string;
  labelSecond: string;
  onChange: (value: boolean) => void;
  iconFirst?: React.ReactNode;
  iconSecond?: React.ReactNode;
}

export const VSwitchButton = ({
  labelFirst,
  labelSecond,
  onChange,
  iconFirst,
  iconSecond,
}: VSwitchButtonProps) => {
  const [active, setActive] = useState<string>("first");

  const handleActive = (value: string) => {
    setActive(value);
    onChange(value === "first");
  };

  return (
    <div className="v-switch-button-container">
      <div
        className="v-switch-button"
        style={{
          backgroundColor:
            active === "first" ? COLORS.Brand.Primary : "#f5f5f5",
          color: active === "first" ? "#fff" : "#000",
        }}
        onClick={() => handleActive("first")}
      >
        {labelFirst}
      </div>
      <div
        className="v-switch-button"
        onClick={() => handleActive("second")}
        style={{
          backgroundColor:
            active === "second" ? COLORS.Brand.Primary : "#f5f5f5",
          color: active === "second" ? "#fff" : "#000",
        }}
      >
        {labelSecond}
      </div>
    </div>
  );
};
